export const ELEMENT_SEARCH_SUBMIT = 'ELEMENT_SEARCH_SUBMIT';
export const ELEMENT_SEARCH_SUCCESS = 'ELEMENT_SEARCH_SUCCESS';
export const ELEMENT_SEARCH_FAILURE = 'ELEMENT_SEARCH_FAILURE';

export const ELEMENT_SEARCH_CLEAR = 'ELEMENT_SEARCH_CLEAR';
export const ELEMENT_SEARCH_SET_QUERY = 'ELEMENT_SEARCH_SET_QUERY';

export const INPUT_FOCUS_INDEX = -1;
